import React from "react";
import { useFormContext } from "react-hook-form";
import { OrderFormData } from "../../hooks/useOrderForm";
import { Calendar } from "../ui/calendar";

interface FormCalendarProps {
  name: keyof OrderFormData;
  placeholder?: string;
  onValueChange?: (value: string) => void;
  disabled?: boolean;
  disabledDates?: (date: Date) => boolean;
}

export const FormCalendar: React.FC<FormCalendarProps> = ({
  name,
  placeholder,
  onValueChange,
  disabled,
  disabledDates,
}) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(name);
  const error = errors[name];

  const calendarValue = value ? new Date(value) : undefined;

  const handleValueChange = (newValue: Date | string) => {
    let stringValue: string;

    if (newValue instanceof Date) {
      // Format as YYYY-MM-DD in local timezone
      const year = newValue.getFullYear();
      const month = String(newValue.getMonth() + 1).padStart(2, "0");
      const day = String(newValue.getDate()).padStart(2, "0");
      stringValue = `${year}-${month}-${day}`;
    } else if (typeof newValue === "string") {
      stringValue = newValue;
    } else {
      stringValue = "";
    }

    setValue(name, stringValue, { shouldValidate: true });
    onValueChange?.(stringValue);
  };

  return (
    <div>
      <Calendar
        value={calendarValue}
        onValueChange={handleValueChange}
        placeholder={placeholder}
        disabled={disabled}
        disabledDates={disabledDates}
      />
      {error && (
        <div className="text-red-400 text-sm mt-2">
          {error.message as string}
        </div>
      )}
    </div>
  );
};
